import _ from 'lodash';

import { AnswersListType } from 'models/answer_panel';
import AttachSnippetAttachments from 'actions/composition/attach_snippet_attachments';
import CreateCompositionFromAnswerType from 'actions/composition/create_composition_from_answer_type';
import { getActiveConversationId } from 'actions/conversation/lib/conversation_helpers';
import { getAnswersList } from 'scripts/application/selectors/answers';
import { getSuggestedAnswersModelVersion } from 'scripts/application/selectors/answers';
import SelectedKbItem from 'models/selected_kb_item';
import { SnippetChannel, SnippetContentType } from 'models/answers/snippet';
import TrackAnswerUsed from 'actions/knowledge_base/track_answer_used';
import UpdateCompositionWithSnippet from 'actions/composition/update_composition_with_snippet';

export default class InsertSelectedAnswer {
  constructor(context) {
    this.context = context;
  }

  run() {
    const answerPanel = this.context.stores.answerPanel.get();
    const { selectedAnswer, selectedAnswerLanguage, selectedAnswerType } = answerPanel;
    if (!selectedAnswer || selectedAnswer.isDisabled || selectedAnswerType === SnippetChannel.INFO) {
      return;
    }

    let insertedItem = SelectedKbItem.create({
      item: selectedAnswer,
      channelType: selectedAnswerType,
      language: selectedAnswerLanguage,
    });
    this.context.stores.selectedKbItem.set(insertedItem);

    const currentLocation = this.context.stores.currentLocation.get();
    const customerId = currentLocation.customerId;

    const { conversations } = this.context.stores.customers.storesFor(customerId);
    const conversationId = getActiveConversationId(conversations);
    let compositionId = currentLocation.currentCompositionId;
    if (!compositionId && conversationId) {
      this.context.executeAction(CreateCompositionFromAnswerType, { answerType: selectedAnswerType, conversationId });
      compositionId = this.context.stores.currentLocation.get().currentCompositionId;
    }

    if (compositionId) {
      this.context.executeAction(AttachSnippetAttachments, {
        compositionId,
        contentChannelType: SnippetContentType[selectedAnswerType],
        item: selectedAnswer,
        language: selectedAnswerLanguage,
      });
      this.context.executeAction(UpdateCompositionWithSnippet, {
        compositionId,
        snippetId: selectedAnswer.id,
        snippetLanguage: selectedAnswerLanguage,
        snippetChannelType: SnippetContentType[selectedAnswerType],
      });
    }

    const search = this.context.stores.answerPanel.get().searchResult;
    const searchText = _.get(search, 'query.text') || '';

    const answerSuggestionsModelVersion = getSuggestedAnswersModelVersion(this.context.stores, { compositionId });

    const { answers, type } = getAnswersList(this.context.stores, { compositionId });

    this.context.analytics.track('Answer Panel - Answer Selected', {
      customerId,
      channelType: selectedAnswerType,
      conversationId,
      compositionId,
      answerId: selectedAnswer.id,
      answerCount: answers.length,
      selectionRank: _.findIndex(answers, answer => answer.id === selectedAnswer.id),
      selectionType: { [AnswersListType.SEARCH]: 'search', [AnswersListType.SUGGESTIONS]: 'suggestion' }[type],
      sortType: type === AnswersListType.SEARCH ? _.get(search, 'query.sort') : 'SUGGESTED',
      searchText,
      version: answerSuggestionsModelVersion, // for backwards compatability
      'exp-answerSuggestionsModelVersion': answerSuggestionsModelVersion,
    });

    this.context.executeAction(TrackAnswerUsed, {
      answer: selectedAnswer,
      channel: selectedAnswerType,
      language: selectedAnswerLanguage,
      method: 'INSERTED',
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/answers/insert_selected_answer.js